import styled, { css } from 'styled-components';
import smileIcon from '../../../images/smile.png';
import smile2xIcon from '../../../images/smile@2x.png';
import sadIcon from '../../../images/sad.png';
import sad2xIcon from '../../../images/sad@2x.png';

function getIconCss(icon, icon2x) {
  return css`
    display: inline-block;
    vertical-align: middle;
    width: 12px;
    height: 13px;
    background-image: url(${icon});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100%;

    @media only screen and (-webkit-min-device-pixel-ratio: 2),
      only screen and (min--moz-device-pixel-ratio: 2),
      only screen and (-o-min-device-pixel-ratio: 2/1),
      only screen and (min-device-pixel-ratio: 2),
      only screen and (min-resolution: 192dpi),
      only screen and (min-resolution: 2dppx) {
      background-image: url(${icon2x});
    }
  `;
}

export default {
  Container: styled.div<{ offset: number }>`
    position: absolute;
    bottom: ${(props) => props.offset}px;
    right: 0;
    width: 100%;
    z-index: 1001;

    bottom: 0;

    @media screen and (min-width: 720px) {
      width: auto;
      bottom: 55px;
      z-index: 10;
    }

    @media screen and (max-height: 280px) {
      bottom: auto;
      top: 0;
    }
  `,

  Content: styled.div`
    position: relative;
    padding: 16px 16px 0;
    background: #fff;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    margin: 8px auto;

    @media screen and (min-width: 720px) {
      max-width: 422px;
      margin: 24px;
    }
  `,

  Title: styled.h1`
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 21px;
  `,

  TicketsTypeTitle: styled.h3`
    margin-top: 16px;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
  `,

  Paragraph: styled.p`
    margin: 12px 0 0;
    font-size: 14px;
    line-height: 18px;
    color: rgba(0, 0, 0, 0.8);
  `,

  AvailabilityMessage: styled.p`
    display: flex;
    flex-wrap: wrap;
    color: rgba(0, 0, 0, 0.8);
    font-size: 14px;
  `,

  AvailabilityItem: styled.span`
    display: flex;
    align-items: center;
    margin-right: 16px;
    margin-bottom: 14px;

    svg {
      margin-right: 4px;
    }
  `,

  BrokerItem: styled.span`
    display: flex;
    align-items: center;
    margin-right: 16px;

    svg {
      width: 20px;
      height: auto;
      margin-right: 4px;
      fill: #000;
    }
  `,

  HideButton: styled.div`
    position: absolute;
    top: 0;
    right: 0;
  `,

  Buttons: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 12px -4px 0;
  `,

  Button: styled.div`
    width: 100%;
    padding: 0 4px;
  `,

  Smile: styled.span`
    ${getIconCss(smileIcon, smile2xIcon)};
  `,

  Sad: styled.span`
    ${getIconCss(sadIcon, sad2xIcon)};
  `,
};
